// extracted by mini-css-extract-plugin
export var dataCell = "_rx-2";
export var dataRow = "_rx-0";
export var headerRow = "_rx-1";